<template>
  <div>
    <div class="flex items-center gap-x-2 mb-3">
      <div
        class="font-secondary font-medium text-[14px] leading-[22px] text-gray-800"
      >
        Page {{ page + 1 }}
      </div>
    </div>

    <MatchTagSummary
      :entries="tagEntries"
      :selected-number="selectedNumber"
      @select="selectMatch"
    />

    <div class="flex flex-col gap-y-3">
      <MatchesDocumentPageImage
        v-for="image in images"
        :key="image.url"
        :page="page"
        :page-url="image.url"
        :page-width="image.width"
        :page-height="image.height"
        :entries="image.entries"
        :selected-number="selectedNumber"
        @select="selectMatch"
        @deselect="selectedNumber = null"
        @view="emit('view', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import MatchTagSummary from './MatchTagSummary.vue'
import MatchesDocumentPageImage from './MatchesDocumentPageImage.vue'
import type { ScoreLevel, Coords } from '@/shared/graphql/router/graphql'
import type { TimelineMatch } from '../timeline-types'
import { computed, ref, watch } from 'vue'

export interface PageMatchEntry {
  number: number
  match: {
    id: string
    level?: ScoreLevel | null
    coords: Coords[]
    timelineMatch: TimelineMatch
  }
}

export interface PageMatchImage {
  url: string
  width?: number
  height?: number
  entries: PageMatchEntry[]
}

const props = defineProps<{
  page: number
  entries: PageMatchEntry[]
  images: PageMatchImage[]
}>()

const emit = defineEmits<{
  view: [matchId: string]
}>()

const tagEntries = computed(() =>
  props.entries.map((entry) => ({
    number: entry.number,
    level: entry.match.level,
  }))
)

const selectedNumber = ref<number | null>(null)

const selectMatch = (number: number) => {
  selectedNumber.value = selectedNumber.value === number ? null : number
}

watch(
  () => props.entries,
  () => {
    selectedNumber.value = null
  }
)
</script>
